export default "__VITE_ASSET__BtDRsgde__"